import React from 'react';

function OSD_Program() {
    return <main>OSD </main>;
}

export default OSD_Program;
